import { ActionIcon, Container, Group, Text, Title, Image, rem } from '@mantine/core';
import './Footer.css';
import Logo from '../Images/Logogvinfotech.png';
import Instalogo from '../Assets/Instagram.png'
import Whatsapp from '../Images/whatsapp.png'
import Linkdin from '../Images/linkedin.png';
import Googlebusiness from '../Images/google.png';

const data = [
  {
    title: 'About',
    links: [
      { label: 'GV InfoTech we are dedicated to transforming your ideas into innovative digital solutions.', link: '/aboutus' },
    ],
  },
  {
    title: 'Contact',
    links: [
      { label: 'QUERY[dot.]GVINFOTECH@GMAIL[dot.]COM, (+91) 977-387-0841, (+91) 770- 183- 6668', link: '/contactus' },
    ],
  },
];







const Footer = () => {
  const groups = data.map((group) => {
    const links = group.links.map((link, index) => (
      <Text
        key={index}
        className={"flink"}
        component="a"
        href={link.link}
        size='xs'
      // onClick={(event) => event.preventDefault()}
      >
        {link.label}
      </Text>
    ));

    return (
      <div className={"fwrapper"} key={group.title}>
        <Title className={"ftitle"} size={'lg'}>{group.title}</Title>
        <Text size='xs' c={'dimmed'}>{links}</Text>
      </div>
    );
  });



  return (
    <>
      <footer className={"footer"}>
        <Container className={"finner"}>
          <div className={"flogo"}>
            {/* <MantineLogo size={30} /> */}
            <Image src={Logo} alt="GV InfoTech" w={100} h={80} radius={'md'} />
            <Text size="xs" c="dimmed" className={"fdescription"} mt={'xs'}>
              ~Transform business digtally
            </Text>
          </div>
          <div className={"fgroups"}>{groups}</div>
        </Container>
        <Container className={"afterFooter"}>
          <Text c="dimmed" size="sm">
            © 2023- {new Date().getFullYear()} GV InfoTech. All rights reserved.
          </Text>

          <Group gap={0} className={"fsocial"} justify="flex-end" wrap="nowrap">
            <ActionIcon size="lg" color="gray" variant="subtle">
              <Image src={Instalogo} alt="Instagram" style={{ width: rem(18), height: rem(18) }} onClick={() => window.location.href = "https://www.instagram.com/gv_infotech_official_2023/ "} />

            </ActionIcon>
            <ActionIcon
              size="lg"
              variant="subtle"
              onClick={() => window.open("https://wa.me/919773870841", "_blank")}
            >
              <Image
                src={Whatsapp}
                alt="WhatsApp"
                style={{ width: rem(18), height: rem(18) }}
              />
            </ActionIcon>
            <ActionIcon
              size="lg"
              variant="subtle"
              onClick={() => window.open("https://wa.me/917701836668", "_blank")}
            >
              <Image
                src={Whatsapp}
                alt="WhatsApp"
                style={{ width: rem(18), height: rem(18) }}
              />
            </ActionIcon>
            <ActionIcon size="lg" color="gray" variant="subtle">
              <Image src={Linkdin} alt="Linkdin" style={{ width: rem(18), height: rem(18) }} onClick={() => window.location.href = "https://www.linkedin.com/company/gv-infotech-2023/"} />
            </ActionIcon>
            <ActionIcon size="lg" color="gray" variant="subtle">
              <Image src={Googlebusiness} alt="GoogleBusiness" style={{ width: rem(18), height: rem(18) }} onClick={() => window.location.href = "https://share.google/aRhDsXmjvMw7FedHz"} />
            </ActionIcon>
          </Group>
        </Container>
      </footer>
    </>
  )
}

export default Footer;